// extracted by mini-css-extract-plugin
export var chevronIcon = "_9b-2";
export var teamName = "_9b-1";
export var teamSwitcherButton = "_9b-0";